module.exports = __webpack_public_path__ + "img/sixpackcarrier31.3840d08a.jpg";